import { render, staticRenderFns } from "./Picodevendas.vue?vue&type=template&id=6baa94c8&"
import script from "./Picodevendas.vue?vue&type=script&lang=js&"
export * from "./Picodevendas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports